import type { TipoManutencao } from "@/modules/financeiro-obras";
import { useEquipamentosSfiDados, useNomeComposto103Dados } from "./use-planejamento-dados";

interface Params {
  obraId: string;
  ativo: boolean;
  grupo: string;
  equipamentoSfiId: string;
  tipoManutencao: TipoManutencao | "";
}

export function useIdentificacaoEquipamento({
  obraId,
  ativo,
  grupo,
  equipamentoSfiId,
  tipoManutencao,
}: Params) {
  const todos = useEquipamentosSfiDados(obraId, null, ativo);
  const doGrupo = useEquipamentosSfiDados(obraId, grupo || null, ativo && grupo !== "");
  const equipamentos = doGrupo.data?.equipamentos ?? [];
  const equipamento = equipamentos.find((item) => item.id === equipamentoSfiId) ?? null;
  const nome = useNomeComposto103Dados(
    obraId,
    ativo && equipamento && tipoManutencao !== ""
      ? { equipamentoSfiId: equipamento.id, tipoManutencao }
      : null,
  );
  const carregado = todos.status === "success";

  return {
    grupos: todos.data?.grupos ?? [],
    equipamentos,
    equipamento,
    composto: equipamento && tipoManutencao !== "" ? nome.data : null,
    carregado,
    semEquipamento: carregado && (todos.data?.equipamentos.length ?? 0) === 0,
    comFalha: todos.status === "error" || doGrupo.status === "error",
  };
}
